import { Box, Typography, Paper } from '@mui/material';

import { FHButton } from '../../components/base';
import ExclamationIcon from '../../components/svgs/ExclamationIcon';
import { FORTA_GRAY4, FORTA_BLUE } from '../../utils/colors';
import { history } from '../../helpers';

export default function PSNRedirect() {
  const handleRedirect = () => {
    history.navigate('/parent-supervisions/new');
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mt: 3,
        display: 'flex',
        alignItems: 'center',
        borderRadius: '8px',
        backgroundColor: FORTA_BLUE.lightest,
        border: `1px solid ${FORTA_BLUE.light1}`,
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 4px ${FORTA_BLUE.light2}`,
        },
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          gap: 0.5,
        }}
      >
        <ExclamationIcon color={FORTA_BLUE.light1} width={28} height={28} />
        <Typography sx={{ color: FORTA_GRAY4, opacity: 0.8, mt: 0.2 }}>
          If only one family is expected to attend, please create a Parent Supervision Note.{' '}
        </Typography>
      </Box>
      <FHButton onClick={handleRedirect}>Go to Parent Supervision</FHButton>
    </Paper>
  );
}
